import React from 'react';

const isValidHtml = (html) => {
  try {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(html, 'text/html');

    const parserErrors = parsedHtml.getElementsByTagName('parsererror');
    if (parserErrors.length > 0) {
      return false;
    }

    const elements = Array.from(parsedHtml.getElementsByTagName('*'));
    const nonStandardTags = elements.filter((el) => {
      const tagName = el.tagName.toLowerCase();
      return (
        document.createElement(tagName).toString() ===
        '[object HTMLUnknownElement]'
      );
    });

    return nonStandardTags.length === 0;
  } catch (error) {
    console.error('Error during validation:', error);
    return false;
  }
};

const HtmlPreview = ({ html }) => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
  };

  if (html && html.trim() !== '' && isValidHtml(html)) {
    return <div
    style={containerStyle}
     dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return (
    <div
    style={containerStyle}
    >
      No preview available
    </div>
  );
};

export default HtmlPreview;
